import { ApplicationConditionalWrapper } from '../ConditionalWrappers/ApplicationConditionalWrapper.tsx';
import { MarketCountryCode } from '@axo/shared/types';
import { Section } from './Section.tsx';
import { SectionDK } from './SectionDK.tsx';

interface IPaymentRemarkSection {
  applicationID: string;
  personID: string;
}

export function PaymentRemarkSection(props: IPaymentRemarkSection) {
  return (
    <>
      <ApplicationConditionalWrapper
        whitelist={[
          {
            marketCountry: [
              MarketCountryCode.Norway,
              MarketCountryCode.Finland,
              MarketCountryCode.Sweden,
            ],
          },
        ]}
      >
        <Section {...props} />
      </ApplicationConditionalWrapper>

      <ApplicationConditionalWrapper
        whitelist={[{ marketCountry: [MarketCountryCode.Denmark] }]}
      >
        <SectionDK {...props} />
      </ApplicationConditionalWrapper>
    </>
  );
}
